import { useStore } from '@/store';
import { Button, Group, Modal } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useSetupStore } from '../../../setup/store';
import { clearLogs } from '@morph-mapper/plugins';
import { clearPersistedSave } from '@/utils';
import { t } from 'i18next';

export const NavigateModal = () => {
  const [
    navTemplateOpen,
    navDomainOpen,
    setIsOpenTemplate,
    setIsOpenDomain,
    isSaveDisabled,
    setIsSaving,
    userId,
    jwt,
  ] = useStore(({ config: c }) => [
    c.isNavTemplateModalOpen,
    c.isNavDomainModalOpen,
    c.setIsNavTemplateModalOpen,
    c.setisNavDomainModalOpen,
    c.isSaveDisabled,
    c.setIsSavingTemplate,
    c.userId,
    c.JWT,
  ]);

  const [setCurrentStep] = useSetupStore((s) => [s.setCurrentStep]);

  const navigate = useNavigate();

  let modalTitle = '';
  let modalContent = '';

  const isOpen = navTemplateOpen || navDomainOpen;

  if (navTemplateOpen) {
    modalTitle = t('menu.save.navigateTemplateTitle');
    modalContent = t('menu.save.navigateTemplateDescription');
  } else if (navDomainOpen) {
    modalTitle = t('menu.save.navigateDomainTitle');
    modalContent = t('menu.save.navigateDomainDescription');
  }

  const setStepforNavigation = () => {
    if (navTemplateOpen) {
      setCurrentStep(1);
    } else if (navDomainOpen) {
      setCurrentStep(0);
    }
  };

  const handleContinueWithoutSaving = () => {
    clearPersistedSave();
    setStepforNavigation();
    navigate(`/`);
    clearLogs();
    closeModal();
  };

  const handleSaveAndContinue = () => {
    setStepforNavigation();
    setIsSaving(true);
    clearLogs();
    closeModal();
  };

  const closeModal = () => {
    if (navTemplateOpen) setIsOpenTemplate(false);
    if (navDomainOpen) setIsOpenDomain(false);
  };

  return (
    <Modal
      title={modalTitle}
      size="xl"
      padding="lg"
      opened={isOpen}
      onClose={closeModal}
    >
      {modalContent}
      <Group position="right" mt="md">
        <Button variant="outline" onClick={handleContinueWithoutSaving}>
          {t('menu.save.continueWithoutSave')}
        </Button>
        <Button
          color="blue"
          onClick={handleSaveAndContinue}
          disabled={isSaveDisabled}
        >
          {t('menu.save.continueSave')}
        </Button>
      </Group>
    </Modal>
  );
};

export default NavigateModal;
